function splitConditionValues(value: unknown): Array<string> {
  const currentConditionValue =
    typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' ? String(value).trim() : '';

  if (!currentConditionValue) {
    return [];
  }

  return currentConditionValue
    .split(',')
    .map((conditionValue) => conditionValue.trim())
    .filter(Boolean);
}

export function hasSuggestedConditionValue(currentValue: unknown, suggestedValue: string): boolean {
  return splitConditionValues(currentValue).includes(suggestedValue.trim());
}

export function toggleSuggestedConditionValue(currentValue: unknown, suggestedValue: string): string {
  const trimmedSuggestedValue = suggestedValue.trim();
  const conditionValues = splitConditionValues(currentValue);

  if (conditionValues.includes(trimmedSuggestedValue)) {
    return conditionValues.filter((conditionValue) => conditionValue !== trimmedSuggestedValue).join(',');
  }

  return [...conditionValues, trimmedSuggestedValue].join(',');
}
